/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * POST /press_release/{release_id}/history
 * @export
 * @interface PostPressReleaseHistorySuccessAndNoDiffResponse
 */
export interface PostPressReleaseHistorySuccessAndNoDiffResponse {
    /**
     * 
     * @type {number}
     * @memberof PostPressReleaseHistorySuccessAndNoDiffResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof PostPressReleaseHistorySuccessAndNoDiffResponse
     */
    message: string;
    /**
     * 最新のプレスリリース履歴のID
     * @type {number}
     * @memberof PostPressReleaseHistorySuccessAndNoDiffResponse
     */
    releaseHistoryId: number;
}

export function PostPressReleaseHistorySuccessAndNoDiffResponseFromJSON(json: any): PostPressReleaseHistorySuccessAndNoDiffResponse {
    return PostPressReleaseHistorySuccessAndNoDiffResponseFromJSONTyped(json, false);
}

export function PostPressReleaseHistorySuccessAndNoDiffResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPressReleaseHistorySuccessAndNoDiffResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'releaseHistoryId': json['release_history_id'],
    };
}

export function PostPressReleaseHistorySuccessAndNoDiffResponseToJSON(value?: PostPressReleaseHistorySuccessAndNoDiffResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'release_history_id': value.releaseHistoryId,
    };
}

